export const reservationInvoicePanel = {
  loadingVerifying: "Verificando…",

  status: {
    draft: "Rascunho",
    sent: "Emitida",
    processing: "Processando",
    pending: "Pendente",
    error: "Erro",
    corrected: "Retificada",
    voided: "Anulada",
  },

  common: {
    cancel: "Cancelar",
    understood: "Entendi",
    optional: "opcional",
    optionalParen: "(opcional)",
    sending: "Enviando…",
    saving: "Salvando…",
    deleting: "Excluindo…",
    emitting: "Emitindo…",
    creating: "Criando…",
    retrying: "Tentando novamente…",
  },

  issued: {
    title: "Faturas emitidas",
    rectifOf: "Retificadora de {code}",
    viewPdf: "Ver PDF",
    sendByWhatsapp: "Enviar por WhatsApp",
    correctTitle: "Retificar (retificadora)",
    voidTitle: "Anular (fatura retificativa)",
  },

  empty: {
    guestRequested: "O hóspede solicitou a fatura",
    noInvoice: "Nenhuma fatura emitida",
    linkSent: "Link enviado",
    requested: "Solicitada",
    requestedSub: "Confira os dados e emita a fatura, ou envie o link para o hóspede confirmar.",
    sub: "Envie o link ao hóspede ou crie a fatura diretamente.",
    copyLinkTitle: "Copiar link para a área de transferência",
    sendLink: "Enviar link",
    createInvoice: "Criar fatura",
    configureHint: "Configure seus dados de faturamento para habilitar este recurso.",
  },

  next: {
    title: "Esta reserva já tem sua fatura",
    sub: "Houve alguma cobrança posterior? Crie outra fatura para esta reserva: ela incluirá apenas as novas cobranças (a hospedagem já faturada não é repetida).",
    button: "Criar outra fatura para esta reserva",
  },

  card: {
    draftRefTitle: "Referência interna do rascunho. O número fiscal é atribuído na emissão.",
  },

  draft: {
    emptyHint: 'Adicione pelo menos uma cobrança em <b>“Novas cobranças”</b> para emitir esta fatura.',
    noteLead: "Rascunho — edite os dados ou adicione cobranças acima; o número e a data são atribuídos na <b>emissão</b>.",
    nextSequential: "Próximo número sequencial",
    estimated: "estimado",
    noteFoot: "O número não é definitivo: quem emitir primeiro fica com ele.",
    confirmEmit: "Confirmar e emitir fatura",
    previewPdf: "Pré-visualizar PDF",
    sendQuote: "Enviar orçamento",
    edit: "Editar fatura",
    discard: "Descartar",
  },

  // Linhas do documento em curso: o que se revê ANTES de emitir.
  concepts: {
    title: "Linhas do documento",
    item: "Artigo",
    qty: "Qtd.",
    unitPrice: "Preço unit.",
    vat: "IVA",
    amount: "Valor",
    linesTotal: "Soma das linhas",
    foot: "É assim que a decomposição vai aparecer na fatura. O PDF tem o detalhe completo.",
    mismatch: "A soma das linhas ({lines}) não coincide com o total do documento ({total}). Verifique antes de emitir.",
  },

  // Lo cobrado y lo que queda a deber. Mismas palabras y mismo orden que el
  // pie del PDF, para que leer la pantalla y leer la factura sea lo mismo.
  cobro: {
    total: "Total do documento",
    nothing: "Sem pagamentos registados",
    due: "Por cobrar",
    assumed: "Não há pagamentos registados nesta reserva. O valor é dado como cobrado a partir da forma de pagamento marcada, e o PDF dirá o mesmo. Se ainda não recebeu, registe o pagamento ou altere a forma de pagamento.",
  },

  actions: {
    sendWhatsapp: "Enviar WhatsApp",
    correct: "Retificar",
    void: "Anular",
    refresh: "Atualizar",
    retry: "Tentar novamente",
    editData: "Editar dados",
    delete: "Excluir",
  },

  wa: {
    title: "Enviar fatura por WhatsApp",
    desc: "A fatura <strong>{code}</strong> será enviada ao hóspede como PDF pelo WhatsApp.",
    issuedFallback: "emitida",
    checkPhone: "Será usado o telefone do hóspede vinculado à reserva",
    checkPdf: "O documento será enviado como PDF",
    send: "Enviar fatura",
  },

  sendLink: {
    title: "Enviar link de faturamento",
    desc: "Será enviado ao hóspede um <strong>link do WhatsApp</strong> para confirmar os dados fiscais e baixar a fatura.",
    checkNoInvoice: "Nenhuma fatura é emitida ainda: o hóspede recebe apenas o link",
    button: "Enviar link",
  },

  retryModal: {
    title: "Tentar emitir novamente",
    desc: "Vamos tentar <strong>emitir esta fatura</strong> novamente com os dados atuais.",
    check1: "É reenviada ao órgão de faturamento eletrônico",
    check2: "Se der certo, o número fiscal definitivo é atribuído",
  },

  voidModal: {
    doneTitle: "Fatura anulada — Fatura retificativa emitida",
    creditNoteIssued: "Fatura retificativa <strong>{code}</strong> emitida",
    chargesReleased: "As cobranças adicionais foram liberadas",
    clientCanRequest: "O cliente pode solicitar a fatura novamente",
    doneHint: "Adicione ou corrija as cobranças pendentes e crie uma nova fatura.",
    formTitle: "Anular fatura / Emitir fatura retificativa",
    formDesc: "Use esta opção quando precisar <strong>adicionar ou alterar serviços/valores</strong>. Será emitida uma <strong>fatura retificativa</strong> que anula a fatura original, e você poderá criar uma nova fatura com as cobranças corretas.",
    stepAnnul: "É emitida uma fatura retificativa fiscal que anula {code}",
    stepFree: "As cobranças são liberadas para adicionar ou corrigir",
    stepNewNumber: "Uma nova fatura é criada com o próximo número",
    notice: "Para corrigir apenas o NIF, nome ou endereço sem alterar valores, use <strong>Corrigir dados</strong>.",
    voiding: "Emitindo fatura retificativa…",
    confirm: "Anular e emitir fatura retificativa",
  },

  edit: {
    titleDraft: "Editar fatura",
    titleClient: "Editar dados do cliente",
    descDraft: "As alterações são salvas instantaneamente. Os dados fiscais são validados sem emitir.",
    descSent: "Ao salvar, o envio será tentado novamente automaticamente.",
    type: "Tipo",
    individual: "Pessoa física",
    individualSub: "Particular",
    company: "Empresa",
    companySub: "Pessoa jurídica",
    legalName: "Razão social",
    fullName: "Nome completo",
    legalNamePlaceholder: "Razão social da empresa",
    fullNamePlaceholder: "Nome e sobrenome",
    country: "País",
    countryPlaceholder: "Selecione o país do hóspede",
    taxRequiredOnEmit: "obrigatório na emissão",
    taxIdPlaceholderCompany: "NIF / CIF da empresa",
    taxIdPlaceholderIndividual: "DNI / NIE · vazio = consumidor final",
    email: "E-mail",
    emailPlaceholder: "email@example.com",
    phone: "Telefone",
    phonePlaceholder: "+34 600 000 000",
    fiscalAddress: "Endereço fiscal",
    addressPlaceholder: "Rua e número",
    city: "Cidade",
    region: "Região / Província",
    zip: "Código postal",
    saveChanges: "Salvar alterações",
    saveAndRetry: "Salvar e tentar novamente",
  },

  deleteModal: {
    title: "Excluir fatura",
    desc: "Esta tentativa de fatura será excluída. O cliente poderá solicitar a fatura novamente do zero.",
    noticeIrreversible: "Esta ação não pode ser desfeita.",
  },

  emit: {
    title: "Confirmar e emitir fatura",
    subtitle: "É registrada oficialmente",
    desc: "Você está prestes a emitir a fatura de {name}.",
    stepNumberEstimate: "É atribuído o número sequencial <b>{code}</b> — quem emitir primeiro fica com ele.",
    stepNumberFinal: "É atribuído o número sequencial <b>definitivo</b> — quem emitir primeiro fica com ele.",
    stepPdf: "O PDF fiscal é gerado e registrado junto ao órgão fiscal.",
    warn: "Uma vez emitida, ela <b>não pode ser editada</b>. Se houver algum erro, será preciso <b>anulá-la e criar uma nova fatura</b> (fatura retificativa ou retificadora).",
    confirm: "Confirmar e emitir",
  },

  newInvoice: {
    title: "Criar outra fatura",
    subtitle: "Para esta mesma reserva",
    desc: "Um <strong>novo rascunho</strong> será aberto para esta reserva.",
    step1: "Ela incluirá <b>apenas as novas cobranças</b> que você adicionar — a hospedagem já faturada não é repetida.",
    step2: "Ela usa os mesmos dados do cliente. O número é atribuído na emissão.",
    createDraft: "Criar rascunho",

    // Facturar toda la reserva o una sola habitación (reservas de varias).
    scopeTitle: "Como quer faturar?",
    whole: "A reserva inteira",
    wholeHint: "Uma única fatura com os {n} quartos.",
    perRoom: "Um quarto",
    perRoomHint: "Cada quarto, a sua fatura. Para quando cada hóspede paga o seu.",
    pickRoom: "Escolha o quarto",
    roomLodging: "Alojamento",
    alreadyInvoiced: "já faturado",
  },

  correction: {
    doneTitle: "Retificadora emitida",
    createdOk: "Retificadora <strong>{code}</strong> criada com sucesso",
    originalKept: "A fatura original permanece como referência fiscal (não é excluída)",
    pdfSoon: "O PDF será gerado em breve",
    title: "Retificar fatura",
    infobox: "Será emitida uma <strong>fatura retificativa retificadora</strong> que substitui fiscalmente <strong>{code}</strong> e inclui as cobranças atuais da reserva. O número original não pode ser alterado (é a lei).",
    reasonLabel: "Motivo da retificação",
    selectReason: "— Selecione um motivo —",
    reasonTaxId: "NIF / CIF ou identificação fiscal incorretos",
    reasonName: "Nome ou razão social incorretos",
    reasonAddress: "Endereço fiscal incorreto",
    reasonEmail: "E-mail incorreto",
    reasonGeneral: "Correção geral dos dados fiscais",
    reasonOther: "Outro (escreva o motivo)",
    customReasonPlaceholder: "Descreva o motivo da retificação…",
    recipientDivider: "Dados do destinatário — altere apenas o que precisar corrigir",
    nameOrLegalName: "Nome / Razão social",
    taxIdFull: "NIF / CIF / Identificação fiscal / Passaporte",
    countryTwoLetters: "(2 letras)",
    paymentDivider: "Forma de pagamento",
    paymentLabel: "Tipo de pagamento",
    paymentUnspecified: "— Não especificado —",
    paymentCash: "Dinheiro",
    paymentCard: "Cartão de crédito / débito",
    paymentTransfer: "Transferência bancária",
    paymentStripe: "Stripe (online)",
    emitRectif: "Emitir retificadora",
  },

  request: {
    typeCompany: "Empresa",
    typeIndividual: "Pessoa física",
    type: "Tipo",
    legalName: "Razão social / Nome",
    taxId: "NIF / CIF",
    address: "Endereço",
    postalCode: "Código postal",
    city: "Cidade",
    state: "Província",
    country: "País",
    email: "E-mail",
  },

  toast: {
    linkSent: "Link de faturamento enviado ao hóspede pelo WhatsApp.",
    alreadyIssued: "Esta reserva já tem uma fatura emitida.",
    cantSendLink: "Não foi possível enviar o link.",
    linkCopied: "Link copiado para a área de transferência.",
    alreadyHasInvoice: "Esta reserva já tem uma fatura.",
    cantGenerateLink: "Não foi possível gerar o link.",
    cantSendWhatsapp: "Não foi possível enviar pelo WhatsApp.",
    invoiceSentWhatsapp: "Fatura enviada pelo WhatsApp.",
    draftCreatedNewCharges: "Rascunho criado com as novas cobranças (sem repetir a hospedagem). Revise e emita.",
    draftCreated: "Rascunho criado. Adicione cobranças e emita quando estiver pronto.",
    alreadyInProgress: "Esta reserva já tem uma fatura em andamento.",
    cantCreateDraft: "Não foi possível criar o rascunho.",
    invoiceEmitted: "Fatura emitida. Gerando o número e o PDF…",
    cantEmit: "Não foi possível emitir a fatura.",
    cantPreview: "Não foi possível gerar a pré-visualização.",
    quoteSent: "Orçamento enviado para {email}",
    cantSendQuote: "Não foi possível enviar o orçamento",
    cantSync: "Não foi possível sincronizar o status.",
    retrying: "Tentando emitir novamente…",
    cantRetry: "Não foi possível tentar novamente.",
    cantVoid: "Erro ao anular a fatura.",
    savedCheckFiscal: "Salvo. Confira o documento fiscal.",
    dataUpdated: "Dados atualizados.",
    cantSaveData: "Não foi possível salvar os dados.",
    invoiceDeleted: "Fatura excluída.",
    cantDelete: "Não foi possível excluir.",
    cantEmitRectif: "Erro ao emitir a retificadora.",
  },
};
